import { gql } from 'graphql-request';

import { batch } from '@distancify/drapejs-litium';
import { fetchPage } from '@drapejs/core';
import { defineReceiver } from '@drapejs/invoker';

import {
  getRecentlyVisitedProductsCacheKey,
  getRecentlyVisitedProductsIdsCacheKey,
} from '@/composables/useRecentlyVisitedProducts';
import { isProductPage } from '@/helpers/page-type';

import { getProductsSearchFields } from './category';

const defaultMaxNumberOfRecentlyVisitedProducts = 10;

export const handleRecentlyVisitedProducts = defineReceiver(
  fetchPage,
  async function (_command, data) {
    if (
      !isProductPage(data) &&
      !containsRecentlyVisitedProductsBlock(data.blocks)
    ) {
      return data;
    }

    const channel = await this.cache.getItem('__channel');
    const cacheKey = getRecentlyVisitedProductsIdsCacheKey(channel.locale);

    let productIds: string[] = (await this.cache.getItem(cacheKey)) || [];

    if (isProductPage(data)) {
      const maxNumberOfRecentlyVisitedProducts =
        channel.website.maxNumberOfRecentlyVisitedProducts ||
        defaultMaxNumberOfRecentlyVisitedProducts;

      const productId = data.dataJson.product.systemId;

      if (productIds.includes(productId)) {
        productIds = productIds.filter((id) => id !== productId);
      }
      productIds.unshift(productId);

      if (productIds.length > maxNumberOfRecentlyVisitedProducts) {
        productIds.pop();
      }

      await this.cache.setItem(cacheKey, productIds);
    }

    if (productIds.length > 0) {
      const filteredProductIds = productIds.filter(
        (x) => x !== data?.dataJson?.product?.systemId
      );

      if (filteredProductIds.length > 0) {
        await this.invoke(batch.scheduleQuery, {
          cacheKey: getRecentlyVisitedProductsCacheKey(channel.locale),
          query: gql`
            elasticSearch{
              recentlyVisitedProducts(productsIds: $productsIds){
                ${getProductsSearchFields()}
              }
          }`,
          variables: {
            productsIds: {
              value: filteredProductIds,
              type: '[Guid]!',
            },
          },
        });
      }
    }

    return data;
  }
);

function containsRecentlyVisitedProductsBlock(blocks) {
  for (let key in blocks) {
    if (!blocks.hasOwnProperty(key)) continue;
    const blockArray = blocks[key] || [];
    for (let block of blockArray) {
      if (block.template === 'RecentlyVisitedProducts') {
        return true;
      }
    }
  }
  return false;
}
